module.exports = __webpack_public_path__ + "img/femalefarmer.12a05c65.png";